import React, { useState } from "react";
import dayjs from "dayjs";
import { Pencil, X } from "lucide-react";
import { optionsGenero } from "../../../../constantes/constantes";

function PerfilEditarComponents({
    email,
    setEmail,
    tester,
    setTester,
    sexoSelected,
    handleSexoSearch,
    handleSexoSelected,
    handleCancelar,
    handleUpdate,
    dataUsuario
}) {
    const [viewEmail, setViewEmail] = useState(false);
    const [viewTester, setViewTester] = useState(false);
    const [viewSexo, setViewSexo] = useState(false);

    const handleViewEmail = () => {
        setViewEmail(!viewEmail);
    };

    const handleViewTester = () => {
        setViewTester(!viewTester);
    };

    const handleViewSexo = () => {
        setViewSexo(!viewSexo);
    };

    return (
        <div className="bg-white rounded-xl border border-gray-200 p-5">
            <div className="space-y-3">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 py-2 border-b border-gray-100">
                    <p className="text-sm font-bold text-gray-800">Nombre:</p>
                    <p className="text-sm text-gray-700">{dataUsuario?.user?.first_name} {dataUsuario?.user?.last_name}</p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 py-2 border-b border-gray-100">
                    <p className="text-sm font-bold text-gray-800">Cedula de Identidad:</p>
                    <p className="text-sm text-gray-700">{dataUsuario?.ci}</p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 py-2 border-b border-gray-100">
                    <p className="text-sm font-bold text-gray-800">Telefono:</p>
                    <p className="text-sm text-gray-700">{dataUsuario?.numero_telefono}</p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 py-2 border-b border-gray-100">
                    <p className="text-sm font-bold text-gray-800">Direccion:</p>
                    <p className="text-sm text-gray-700">{dataUsuario?.direccion}</p>
                </div>

                {viewEmail ? (
                    <div className="py-2 border-b border-gray-100 flex items-center gap-3">
                        <div className="flex-1">
                            <p className="text-sm font-bold text-gray-800 mb-1">Email:</p>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                autoCapitalize="none"
                                autoCorrect="off"
                                placeholder="Ingrese email"
                                className="w-full px-3 py-2 rounded-lg bg-[#f1f5f9] border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200"
                            />
                        </div>
                        <button
                            type="button"
                            aria-label="cerrar"
                            onClick={handleViewEmail}
                            className="p-2 rounded-lg hover:bg-gray-100 text-gray-600"
                        >
                            <X size={18} />
                        </button>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 py-2 border-b border-gray-100">
                        <div className="flex items-center gap-2">
                            <p className="text-sm font-bold text-gray-800">Email:</p>
                            <button
                                type="button"
                                aria-label="editar"
                                onClick={handleViewEmail}
                                className="p-1 rounded-md hover:bg-gray-100 text-gray-600"
                            >
                                <Pencil size={15} />
                            </button>
                        </div>
                        <p className="text-sm text-gray-700">{email}</p>
                    </div>
                )}

                {viewTester ? (
                    <div className="py-2 border-b border-gray-100 flex items-center gap-3">
                        <div className="flex-1">
                            <p className="text-sm font-bold text-gray-800 mb-1">Acceso a Pruebas</p>
                            <label className="inline-flex items-center gap-2 text-sm text-gray-700">
                                <input
                                    type="checkbox"
                                    checked={tester}
                                    onChange={(e) => setTester(e.target.checked)}
                                    className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                />
                                Es Tester? Usuario con acceso a Sorteos y Promociones (Paseo Plus) de Prueba
                            </label>
                        </div>
                        <button
                            type="button"
                            aria-label="cerrar"
                            onClick={handleViewTester}
                            className="p-2 rounded-lg hover:bg-gray-100 text-gray-600"
                        >
                            <X size={18} />
                        </button>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 py-2 border-b border-gray-100">
                        <div className="flex items-center gap-2">
                            <p className="text-sm font-bold text-gray-800">Usuario Tester:</p>
                            <button
                                type="button"
                                aria-label="editar"
                                onClick={handleViewTester}
                                className="p-1 rounded-md hover:bg-gray-100 text-gray-600"
                            >
                                <Pencil size={15} />
                            </button>
                        </div>
                        <p className="text-sm text-gray-700">{tester ? "Si" : "No"}</p>
                    </div>
                )}

                {viewSexo ? (
                    <div className="py-2 border-b border-gray-100 flex items-center gap-3">
                        <div className="flex-1">
                            <p className="text-sm font-bold text-gray-800 mb-1">Sexo</p>
                            <div className="relative w-full">
                                <select
                                    value={sexoSelected?.value || "masculino"}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        handleSexoSearch(value);
                                        handleSexoSelected(optionsGenero.find((option) => option.value === value) || null);
                                    }}
                                    className="appearance-none w-full px-3 py-2 pr-8 rounded-lg bg-[#f1f5f9] border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200 cursor-pointer"
                                >
                                    {optionsGenero.map((option) => (
                                        <option key={option.id} value={option.value}>{option.label}</option>
                                    ))}
                                </select>
                                <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">▾</span>
                            </div>
                        </div>
                        <button
                            type="button"
                            aria-label="cerrar"
                            onClick={handleViewSexo}
                            className="p-2 rounded-lg hover:bg-gray-100 text-gray-600"
                        >
                            <X size={18} />
                        </button>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 py-2 border-b border-gray-100">
                        <div className="flex items-center gap-2">
                            <p className="text-sm font-bold text-gray-800">Sexo:</p>
                            <button
                                type="button"
                                aria-label="editar"
                                onClick={handleViewSexo}
                                className="p-1 rounded-md hover:bg-gray-100 text-gray-600"
                            >
                                <Pencil size={15} />
                            </button>
                        </div>
                        <p className="text-sm text-gray-700">{sexoSelected?.label}</p>
                    </div>
                )}

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 py-2">
                    <p className="text-sm font-bold text-gray-800">Fecha de registro:</p>
                    <p className="text-sm text-gray-700">{dayjs(dataUsuario?.created_at).format("DD/MM/YYYY")}</p>
                </div>
            </div>

            <div className="flex flex-wrap items-center gap-4 pt-6 mt-6 border-t border-gray-200">
                <button
                    type="button"
                    onClick={handleUpdate}
                    className="px-6 py-2 bg-[#104063] hover:bg-[#0d3553] text-white rounded-lg font-medium transition-colors"
                >
                    Guardar Cambios
                </button>

                <button
                    type="button"
                    onClick={handleCancelar}
                    className="px-6 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors"
                >
                    Cancelar
                </button>
            </div>
        </div>
    );
}

export default PerfilEditarComponents;
